import { Navigate } from 'react-router-dom';
import { MainContent } from '../components';
import { DashboardPage } from '../features/dashboard';
import { selectCurrentUser } from '../features/user';
import { useAppSelector } from '../store/hooks';
import { UserRole } from '../types';

/**
 * Home route component that shows dashboard for Supervisor/CSR/Admin
 * and MainContent for other roles
 */
const HomeRoute = () => {
  const currentUser = useAppSelector(selectCurrentUser);

  if (!currentUser) {
    return <MainContent />;
  }

  // Show dashboard for Supervisor, CSR, and Administrator
  if (
    currentUser.role === UserRole.SUPERVISOR ||
    currentUser.role === UserRole.CSR ||
    currentUser.role === UserRole.ADMINISTRATOR
  ) {
    return <DashboardPage />;
  }

  // Redirect Dealers to order management
  if (currentUser.role === UserRole.DEALER) {
    return <Navigate to="/order-management" replace />;
  }

  // Default to MainContent for other cases
  return <MainContent />;
};

export default HomeRoute;
